// NOTE extend with new list/detail pairs as needed
export const listDetailPairs: Record<string, string> = {
  people: 'people-slug',
  rooms: 'rooms-slug',
}

// detail pages that open as an overlay on top of their list — the list stays
// mounted behind them, so it has to keep its scroll position
export const overlayDetailNames = new Set(['people-slug'])

export const detailToListName: Record<string, string> = Object.fromEntries(
  Object.entries(listDetailPairs).map(([listName, detailName]) => [detailName, listName])
)

// remembers each list page's scroll position so it can be restored when
// navigating back from its detail page
export const listScrollPositions = new Map<string, { left: number, top: number }>()
